import script from "./AInfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AInfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AInfoPanel.vue?vue&type=style&index=0&id=0abfb4b4&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abfb4b4"]])

export default __exports__